<ax-snackbar color="red" [dismissible]="false" [timeout]="50000">{{ errorMessage }}</ax-snackbar>
